import {getQueryParams} from "@helpers/searchParams/helpers";

export const buildPathRootNavigateSingleVoyage = (path: string) => {
    const accountId = getQueryParams('accountId');
    if (!accountId?.length) {
        return path
    }
    return `${path}?accountId=${accountId}`;
}